import React from 'react';
import { motion } from 'framer-motion';

const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 -z-20 overflow-hidden pointer-events-none">
      {/* Base Grid */}
      <div className="absolute inset-0 grid-bg opacity-60" />

      {/* Animated Scanline */}
      <motion.div
        initial={{ top: '-10%' }}
        animate={{ top: '110%' }}
        transition={{ duration: 8, repeat: Infinity, ease: 'linear' }}
        className="absolute left-0 right-0 h-[2px] bg-brand/10 shadow-[0_0_15px_rgba(0,255,136,0.3)] z-10"
      />

      {/* Floating Particles/Glows */}
      {[...Array(5)].map((_, i) => (
        <motion.div
          key={i}
          initial={{
            x: Math.random() * 100 + '%',
            y: Math.random() * 100 + '%',
            scale: 1,
            opacity: 0.1
          }}
          animate={{
            x: [
              Math.random() * 100 + '%',
              Math.random() * 100 + '%',
              Math.random() * 100 + '%'
            ],
            y: [
              Math.random() * 100 + '%',
              Math.random() * 100 + '%',
              Math.random() * 100 + '%'
            ],
            scale: [1, 1.5, 1],
            opacity: [0.1, 0.2, 0.1]
          }}
          transition={{
            duration: 15 + Math.random() * 10,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="absolute w-[400px] h-[400px] bg-brand/5 rounded-full blur-[100px]"
        />
      ))}

      {/* Radial Vignette */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#050805]/20 to-[#050805]" />
    </div>
  );
};

export default AnimatedBackground;
